"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUpMongodbLogger = void 0;
const logger_1 = require("../node/util/logger");
const logEvent = (type, event) => {
    if (['ismaster', 'listCollections', 'ping'].includes(event.commandName)) {
        return;
    }
    logger_1.mongoDBLogger.info({ type, event });
};
const setUpMongodbLogger = (connection) => {
    ['commandStarted', 'commandSucceeded', 'commandFailed'].forEach((commandType) => {
        connection.on(commandType, (event) => logEvent(commandType, event));
    });
};
exports.setUpMongodbLogger = setUpMongodbLogger;
